import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const OperationTypesWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default OperationTypesWrapper